import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Announcement } from '../../shared/models/announcement';
import { DATA } from '../../shared/data';

@Component({
  selector: 's9-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss'],
})
export class AnnouncementsComponent {
  data = DATA;

  announcements$: BehaviorSubject<Announcement[]> = new BehaviorSubject<
    Announcement[]
  >(this.data.announcements);
}
